module.exports = __webpack_public_path__ + "media/images/icons/Hvezdicky/starEmpty-36680423a2bddfc1ea532fb1daac4fe4.svg";